import dataPeriDabi from "../../../../src/data/periprocedureel-beleid-dabigatran.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriDabi,
  BasicCollapse,
  React
};